import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TooltipTranslationService } from '~shared/translations';
import { EventKpisCategory, Lottery } from '~core/models';
import { TablesTranslations } from '~shared/components/tables/tables-translations.service';

/**
 * Handles event categories list.
 */
@UntilDestroy()
@Component({
  selector: 'app-event-categories-list',
  templateUrl: './event-categories-list.component.html',
})
export class EventCategoriesListComponent implements OnInit, OnDestroy {
  public columns: Array<string> = [];
  public keys: Array<Array<string>> = [];
  public spinnerName: string = 'eventDashboardRefresh';

  @Input() public selectedLottery: Lottery;
  @Input() public categories: Array<EventKpisCategory>;
  @Input() public isPanelOpened: boolean = true;
  @Output() public isPanelOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    public tablesTranslations: TablesTranslations,
    public tooltipTranslations: TooltipTranslationService,
  ) {
    this.columns.push(
      '',
      this.tablesTranslations.i18nPriceCategory,
      this.tablesTranslations.i18nPrimaryRequested,
      this.tablesTranslations.i18nSecondaryRequested,
      this.tablesTranslations.i18nAvailability,
    );
    this.keys.push(['color', 'name', 'displayPrimaryRequests', 'displaySecondaryRequests', 'capacity']);
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void { }
}
